import { render, staticRenderFns } from "./Recently.vue?vue&type=template&id=15992f9c&scoped=true"
import script from "./Recently.vue?vue&type=script&lang=js"
export * from "./Recently.vue?vue&type=script&lang=js"
import style0 from "./Recently.vue?vue&type=style&index=0&id=15992f9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15992f9c",
  null
  
)

export default component.exports